import { MutationResult, QueryResult } from 'react-query';

/**
 * For use in conjunction with `useQuery` or `useMutation`, to determine whether a query
 * has initiated.
 */
export const hasQueryInitiated = <T>({ isIdle, isSuccess, isError, data }: QueryResult<T> | MutationResult<T>) =>
  Boolean(!isIdle || isSuccess || isError || data);
